/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2022 ICEMEDX, Inc.
***********************************************/
import { IceMultimediaAttributes } from './IceMultimediaAttributes';
import { IceMultimediaCanvas } from './IceMultimediaCanvas';
import { IcePoint } from './IceMultimediaStroke';

export class IceMultimediaText {
  data: any = null;
  attributes: IceMultimediaAttributes = null;
  point: IcePoint = null;

  constructor(attr: IceMultimediaAttributes, pt: IcePoint, dat: any) {
    this.attributes = attr;
    this.data = dat;
    this.point = pt;
  }

  draw(canvas: IceMultimediaCanvas): void {
    if (canvas == null) return;

    let context = canvas.context;
    context.font = canvas.defaultAttributes.font;
    context.strokeStyle = canvas.defaultAttributes.fillcolor;
    context.fillText(this.data, this.point.x, this.point.y);
    document.getElementById(context.canvas.id).style.cursor = "pointer";
  }
}
